import { useQueryClient } from '@tanstack/react-query';
import React, { useCallback, useState } from 'react';
import { Menu } from '../../../../ui';
import { DropMenuButton } from '../../../../ui/MenuButton';
import { Flexer } from '../../elements/LayoutElements';
import { useOnTemplateCopyLink, useOnTemplateDelete } from '../TemplateHooks';
import { TemplateWithStarData } from './TemplateListView';

export const TemplateActionMenu = React.memo<{ template: TemplateWithStarData, readonly?: boolean }>(({ template, readonly }) => {

    const qc = useQueryClient();
    const [open, setOpen] = useState(false);

    const onClose = useCallback(() => {
        setOpen(false);
        return true;
    }, []);

    const onInvalidate = useCallback(() => {
        qc.invalidateQueries(['templates.list', 'custom']);
    }, []);

    const onCopyLink = useOnTemplateCopyLink(template.id, onClose);
    const onDelete = useOnTemplateDelete(template.id, {
        onInvoke: onClose,
        onComplete: onInvalidate,
    });

    return <Flexer margin="0 .5">
        <DropMenuButton icon="deqo://icons/hero/dots-horizontal" open={open} setOpen={setOpen}>
            <Flexer minWidth="12">
                <Menu>
                    <Menu.Item onClick={onCopyLink}>
                        <Menu.ItemText>Copy Create Link</Menu.ItemText>
                    </Menu.Item>
                    <a target="_blank" href={`/TP/${template.id}`} rel="noreferrer" onClick={onClose}>
                        <Menu.Item>
                            <Menu.ItemText>Preview Template</Menu.ItemText>
                        </Menu.Item>
                    </a>
                    {template.team && !readonly && <>
                        <Menu.Divide />
                        {/* <Menu.Item onClick={null}>Edit Metadata...</Menu.Item> */}
                        <Menu.Item onClick={onDelete}>
                            <Menu.ItemText>Delete</Menu.ItemText>
                        </Menu.Item>
                    </>}
                </Menu>
            </Flexer>
        </DropMenuButton>
    </Flexer>;
});
